import { take, cancel, select } from "redux-saga/effects"
import {
  process as selectProcess,
  involved as selectInvolved,
} from "../selectors"
import { types } from "../actions"

export default function* releaseSaga() {
  while (true) {
    const action = yield take([types.release, types.involve])

    const { engine, model, query } = action

    if (action.type === types.release) {
      const involved = yield select(selectInvolved, engine, model, query)

      if (!involved) {
        const process = yield select(selectProcess, engine, model, query)

        if (process) {
          // Cancel current process whatevet it is
          yield cancel(process.task)
        }
      }
    } else if (action.type === types.involve) {
      // const involved = yield select(selectInvolved, engine, model, query)
      // Involve each collection item
      // TODO: involve each item
    }
  }
}
